import Image from "next/image";
import "@/common/Common.css";
export const AutoVerkaufenGrid = ({
  image,
  // Linke box
  leftTitle,
  leftText,
  //rechts erste box
  rightFirstTitle,
  rightFirstText,
  //rechts zweite box
  rightSecondTitle,
  rightSecondText,
  fontSize = "36px",
}) => {
  return (
    <div className="CarValueBoxes-Autoverkaufen">
      <div className="AV-left">
        <Image
          src={image}
          alt="Wie viel ist dein Auto wert"
          className="autowertbestimmen"
          sizes="(max-width: 1124px) 100vw, 520px"
        />
        <div className="AV-left-text-wrapper">
          <h2 style={{ fontSize: fontSize }}>{leftTitle}</h2>
          <>{leftText}</>
        </div>
      </div>
      <div className="AV-right">
        <div className="AV-right-first">
          <div className="AV-right-first-text-wrapper">
            <h2 style={{ fontSize: fontSize }}>{rightFirstTitle}</h2>
            <>{rightFirstText}</>
          </div>
        </div>

        <div className="AV-right-second">
          <div className="AV-right-second-text-wrapper">
            <h2 style={{ fontSize: fontSize }}>{rightSecondTitle}</h2>
            <>{rightSecondText}</>
          </div>
        </div>
      </div>
    </div>
  );
};
